import React, { createContext, useContext, useReducer, useRef } from 'react';
import update from 'immutability-helper';
import { useSourceFields } from './FieldSourceContext';

const FieldsContext = createContext();

function fieldsReducer(state, action) {
  switch (action.type) {
    case 'add':
      if (state && state.length > 0) {
        const newIndex = action.index || state.length;

        return update(state, {
          // set all other fields to isEditing false
          $apply: currentState => currentState.map(v => ({ ...v, isEditing: false })),
          // add new field at the specified index
          $splice: [[newIndex, 0, ...action.values]],
        });
      } else {
        return action.values;
      }
    // Unlike 'add', leaves any open editor (and its unsaved changes) as it is.
    case 'append': {
      return [...(state ?? []), ...action.values];
    }
    case 'set': {
      return update(state, {
        $set: action.values,
      });
    }
    case 'sync': {
      return update(state, {
        $set: action.values,
      });
    }
    case 'update': {
      if (action.item._id) {
        const index = state.findIndex(item => item._id === action.item._id);

        return update(state, {
          [index]: {
            $set: action.values,
          },
        });
      } else {
        const index = state.findIndex(item => item.key === action.item.key);

        return update(state, {
          [index]: {
            $set: action.values,
          },
        });
      }
    }
    case 'delete': {
      if (action.item._id) {
        return state.filter(f => f._id !== action.item._id);
      } else {
        return state.filter(f => f.key !== action.item.key);
      }
    }
    default:
      return state;
  }
}

export const FieldsProvider = ({ children }) => {
  const fields = useSourceFields();
  const [state, dispatch] = useReducer(fieldsReducer, Array.isArray(fields) ? fields : []);

  const prevFieldsRef = useRef(fields);
  if (fields !== prevFieldsRef.current) {
    prevFieldsRef.current = fields;
    if (Array.isArray(fields) && fields.length > 0) {
      const hasLocalEdits = state.some(field => field.isEditing || field.isNew);
      if (!hasLocalEdits) {
        dispatch({ type: 'sync', values: fields });
      }
    }
  }

  return <FieldsContext.Provider value={{ state, dispatch }}>{children}</FieldsContext.Provider>;
};

export const useFields = () => useContext(FieldsContext);
